import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full text-white pt-8 mb-32">
      <div className="p-4 mx-auto flex flex-col justify-center">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <p className="text-xl mt-10">
          As a freelance developer, I have had the opportunity to work on a
          diverse range of projects, collaborating with clients from various
          industries. I believe in translating their unique visions into reality
          through cutting-edge technologies and innovative design practices.
        </p>
        <p className="text-xl mt-10">
          Whether you're an individual, startup, or established business, I am
          dedicated to crafting tailored web solutions that align with your
          specific goals and requirements. I take pride in my ability to
          communicate effectively, ensuring a collaborative and transparent
          development process from start to finish.
        </p>
        <p className="text-xl mt-10">
          Feel free to explore my portfolio and get in touch to discuss how I
          can contribute to your next web development project. Let's bring your
          ideas to life and create something truly amazing together!
        </p>
        <br />
      </div>
    </div>
  );
};

export default About;
